import { searchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import Search from "@insite/mobius/Icons/Search";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";


searchInputStyles.input = {
    sizeVariant: "default",
    iconProps: {
        src: Search,
        color: "white",
        css: css`
            background-color: ${getColor("secondary.main")};
            border-radius: 0 10px 10px 0 !important;
            top: 0 !important;
            right: 0 !important;
            width: 40px !important;
            height: 50px !important;
            padding: 10px !important;
        `,
    },
    border: "underline",
    cssOverrides: {
        formField: css` width: 100%;`,
        formInputWrapper: css`
                        input {
                            border-radius: 10px !important;
                            height: 50px !important;
                        }`,
    },
};
